<template>
    <div class="modal fade" id="confirmDeleteProduct" tabindex="-1" role="dialog" aria-labelledby="confirmDeleteProduct" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content campaign-g-addedit">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLongTitle">{{heading}}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click = "closeDeleteConfirmModal">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <p>Are you sure, you want to delete?</p>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" @click = "closeDeleteConfirmModal">No</button>
                    <button type="button" @click="deleteSelectedProducts" class="btn btn-primary" data-dismiss="modal">Yes</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name:'ProductListDeleteConfirmModal',
    data() {
        return {

        }
    },
    props: {
        heading:{
            type: String,
            required: false,
            default:'Delete Product'
        }
    },
    methods: {
        deleteSelectedProducts() {
            this.$emit('deleteSelectedProducts')
        },
		closeDeleteConfirmModal(){
			this.$emit('closeDeleteConfirmModal')
		}
    },
}
</script>

<style lang="scss">

</style>
